import { takeLatest, call, put, delay, takeEvery, select } from 'redux-saga/effects';
import { sendLog, decodeJWT } from '@siteground/styleguide';

import { CHAT_LAYOUT_DOM_ID } from '../../constants/dom-ids';
import { setChatMinimized, setChatShaking } from '../actions/from-client-frontend';

import * as FromMainAppActions from '../actions/from-main-app';
import * as FromClientFEActions from '../actions/from-client-frontend';

import { initAppEventsWatchers } from './main-app-events-watcher';
import { authenticateVisitor } from './visitor-token-helpers';

import { CHAT_STATE } from '../../constants';

import { getClientToken } from '../../selectors/chat-session';
import { getDebugEvents } from '../../selectors/debug';

import { debugEvent } from '../../actions/debug';
import { getJwtBodyPart } from '../utils/jwt';

export function* onStartAuthenticatedChat({ action, onAuthenticated }) {
  const clientToken = yield select(getClientToken);

  yield put(
    debugEvent({
      name: 'onStartAuthenticatedChat',
      payload: {
        clientToken: getJwtBodyPart({ token: clientToken })
      }
    })
  );

  yield call(authenticateVisitor, {
    onAuthenticated,
    onFailedToLoadVisitorToken: function* () {
      yield put(
        debugEvent({
          name: 'failedToLoadVisitorToken'
        })
      );

      yield put(FromClientFEActions.failedToLoadVisitorToken());
    },
    onFailedAuthentication: function* (err, payload) {
      yield put(FromClientFEActions.setChatStatus(CHAT_STATE.FAILED_AUTHENTICATION_WITH_CLUSTER));

      // Error logging this specific case
      const clientToken = yield select(getClientToken);
      const debugEvents = yield select(getDebugEvents);

      const { user_id = null, client_id = null } = decodeJWT(clientToken);

      sendLog({
        error: `Chat-Error --->>> ${err}`,
        errorInfo: {
          componentStack: 'Failed to start tech chat, due to failed authentication to cluster'
        },
        data: JSON.stringify({
          agent: window.navigator.userAgent,
          user_id,
          client_id,
          err,
          payload,
          debugEvents
        })
      });
    }
  });
}

export function* onStartChatTechnicalFromMainApp(action) {
  yield call(onStartAuthenticatedChat, {
    action,
    onAuthenticated: function* () {
      yield put(
        debugEvent({
          name: 'onStartChatTechnicalFromMainApp -> onAuthenticated'
        })
      );

      yield put(FromClientFEActions.requestStartChatTechincal(action.payload));
    }
  });
}

export function* onStartChatCancellationFromMainApp(action) {
  const { payload } = action;
  const { client, cancellation, cur_code, local_phone, request_id } = payload;

  yield call(onStartAuthenticatedChat, {
    action,
    onAuthenticated: function* () {
      yield put(
        FromClientFEActions.requestStartChatCancellation({
          client,
          cancellation,
          cur_code,
          local_phone,
          request_id
        })
      );
    }
  });
}

export function* onIndicateChatIsActive(action) {
  const chatDomElement = document.getElementById(CHAT_LAYOUT_DOM_ID);

  if (!chatDomElement) {
    return;
  }

  yield put(setChatMinimized(false));
  yield put(setChatShaking(true));

  yield delay(1000);

  yield put(setChatShaking(false));
}

export default function* () {
  initAppEventsWatchers();

  yield takeLatest(FromMainAppActions.START_CHAT_TECHNICAL, onStartChatTechnicalFromMainApp);
  yield takeLatest(FromMainAppActions.START_CHAT_CANCELLATION, onStartChatCancellationFromMainApp);
  yield takeEvery(FromMainAppActions.INDICATE_CHAT_IS_ACTIVE, onIndicateChatIsActive);
}
